import {MutationTree} from "vuex";
import {SmppConnectionState} from "@/store/settings/smpp_connections/types";

export const mutations: MutationTree<SmppConnectionState> = {
  setSmppConnections: (state, payload) => {
    state.smppConnections = payload
  },
  setSmppConnectionItem: (state, payload) => {
    state.smppConnectionItem = payload
  },
  setServerNames: (state, payload) => {
    state.serverNames = payload
  }
}